import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core'
import axios from 'axios'

import { isRequired, isValidPassword, matchPassword } from 'utils/formValidations'

import { Form, FormInput } from 'components/forms'
import { PasswordHelper } from 'components/virtual/inputs'
import Button from 'components/virtual/buttons/Button'
import Text from 'components/texts/Text'

import ErrorBox from './ErrorBox'

const useStyles = makeStyles({
  input: {
    marginBottom: 18,
  },
  passwordHelper: {
    marginBottom: 24,
  },
  submitButton: {
    marginBottom: 24,
  },
  subtitle: {
    marginBottom: 38,
  },
  title: {
    marginBottom: 16,
  },
})

function UpdatePasswordForm() {
  const classes = useStyles()

  const [error, setError] = useState('')
  const [formValid, setFormValid] = useState(true)
  const [loading, setLoading] = useState(false)
  const [passwordMatch, setPasswordMatch] = useState('')
  const [updated, setUpdated] = useState(false)

  const exposeValues = form => {
    setFormValid(form.valid)
    setPasswordMatch(form.values.password)
  }

  const disabled = loading || !formValid

  const updatePassword = async ({ password, passwordConfirm }) => {
    setLoading(true)
    setError('')
    try {
      await axios.post('/update-password', {
        password,
        passwordConfirm,
      })
      setUpdated(true)
      setLoading(false)
    } catch (err) {
      setError(
        err.response.data
          || 'There was an error updating your password. Please contact hello@dojomojo.com'
      )
      setLoading(false)
    }
  }

  return updated ? (
    <>
      <div className={classes.title}>
        <Text size={34}>Password Updated</Text>
      </div>
      <div className={classes.subtitle}>
        <Text charcoalLight size={16}>
          Your password has been reset.
        </Text>
      </div>
      <div className={classes.submitButton}>
        <Button
          color="primary"
          fullWidth
          id="Login"
          label="Log in"
          onClick={() => (window.location.href = '/')}
          size="medium"
          type="contained"
        />
      </div>
    </>
  ) : (
    <>
      <div className={classes.title}>
        <Text size={34}>Reset Password</Text>
      </div>
      <div className={classes.subtitle}>
        <Text charcoalLight size={16}>
          Please enter your new password.
        </Text>
      </div>
      {!!error && <ErrorBox value={error} />}
      <Form
        exposeValues={exposeValues}
        initialValues={{ password: '', passwordConfirm: '' }}
        onSubmit={updatePassword}
        withSubmit="updatePassword"
      >
        <div className={classes.input}>
          <FormInput
            compact
            disableErrorText
            fullWidth
            label="Password"
            name="password"
            showToggle
            theme="virtual"
            type="password"
            useComponentError
            validations={[isRequired, isValidPassword]}
          />
        </div>
        <div className={classes.input}>
          <FormInput
            compact
            disableErrorText
            fullWidth
            label="Confirm Password"
            name="passwordConfirm"
            theme="virtual"
            type="password"
            useComponentError
            validations={[isRequired, isValidPassword, matchPassword(passwordMatch)]}
          />
        </div>
        <div className={classes.passwordHelper}>
          <PasswordHelper value={passwordMatch} />
        </div>
      </Form>
      <div className={classes.submitButton}>
        <Button
          color="primary"
          disabled={disabled}
          fullWidth
          id="updatePassword"
          label="Update Password"
          size="medium"
          type="contained"
        />
      </div>
    </>
  )
}

export default React.memo(UpdatePasswordForm)
